<template>
  <div
    class="modal has-overflow"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">
            Add Document
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Document Name*</label>
            <v-text-field 
              required
              placeholder="Enter Document Name"
              v-model="document.document_name">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Description</label>
            <v-text-area 
              placeholder="Enter Document Description"
              v-model="document.document_desc"
              rows="3">
            </v-text-area>
          </div>

          <div class="field">
            <label class="label">Document Type*</label>
            <v-select
              required
              :options="documentTypes"
              item-text="type_name"
              item-value="id"
              v-model="document.document_type_id"
            />
          </div>

          <div class="field">
            <label class="label">Document Upload*</label>
            <v-drop-zone
              id="documentUpload"
              v-model="attachment.file"
              :file-name.sync="attachment.name"
              height="120px">
            </v-drop-zone>
          </div>

        </v-form>
        
        <footer class="modal-card-foot">
          <button 
            :disabled="!valid || !attachment.file || saving"
            :class="{ 'is-loading': saving }"
            class="button is-primary" 
            @click.stop="save()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VTextArea from '@/components/base/VTextArea'
import VSelect from '@/components/base/VSelect'
import VForm from '@/components/base/VForm'
import VDropZone from '@/components/base/VDropZone'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    documentTypeId: {
      type: [String, Number]
    }
  },
  components: { 
    VForm, VTextField, VTextArea, VSelect, VDropZone
  },
  data() {
    return {
      valid: false,
      document: {
        document_name: null,
        document_desc: null,
        document_type_id: null
      },
      attachment: {
        file: null,
        name: null,
        url: null
      },
      saving: false
    }
  },
  computed: {
    ...mapState("documents", ["documentTypes"])
  },
  watch: {
    value() {
      if (this.documentTypeId) {
        this.document.document_type_id = this.documentTypeId;
      }
    }
  },
  methods: {
    ...mapActions("documents", ["addDocument", "addAttachment"]),
    ...mapMutations("app", ["setNotification"]),
    save() {
      this.saving = true;
      this.addDocument(this.document).then(resp => {
        let formData = new FormData();
        formData.append('attachment', this.attachment.file, this.attachment.file.name)
        this.addAttachment({
          documentId: resp.data.id, 
          data: formData
        }).then(() => {
          this.saving = false;
          this.close(true);
          this.setNotification({
            status: true,
            type: 'success',
            message: 'Document successfully added'
          })
        })
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>